import { Stack, Text } from '@chakra-ui/react'
import { faClipboardQuestion } from '@fortawesome/pro-duotone-svg-icons'

import * as url from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

import RestrictedPageAccess from './RestrictedPageAccess'

export default function RestrictedPageRejected(): JSX.Element {
  return (
    <RestrictedPageAccess
      alignCenter
      faIcon={faClipboardQuestion}
      iconColor="primary.fg"
      title="You're almost there!"
      hideHomeButton
      hideLoginButton
      description={
        <Stack direction="column" spacing="32px">
          <Text>
            It looks like we need more information to approve your Schoolhouse application. Please
            send our safety team a{' '}
            <ShwLink href={url.getOnboardingVideoAskUrl()}>quick video message</ShwLink>&#32;about
            why you&apos;d like to use Schoolhouse.
          </Text>
          <Text>
            If you have any questions or issues, please reach out to our{' '}
            <ShwLink href={url.faq.getArticleUrl('how-do-i-contact-the-schoolhouse-team')}>
              User Support
            </ShwLink>
            . Thanks!
          </Text>
        </Stack>
      }
    />
  )
}
